export const PROFILE_MODULE = 'profile'
// Action && Mutation
export const GET_PROFILE = 'getProfile'
export const PROFILE_DATA = 'profileData'
export const SET_EMAIL = 'setEmail'
export const CHANGE_PASSWORD = 'changePasswordPatch'
export const CHANGE_DISPLAY_NAME = 'changeDisplayName'
export const CREATE_PASSWORD = 'createPasswordPatch'
export const UPLOAD_PROFILE_IMAGE = 'patchUploadImage'
export const DELETE_PROFILE_IMAGE = 'patchDeleteImage'
export const CHANGE_EMAIL_REQUEST = 'postChangeEmailRequest'
export const CHANGE_EMAIL = 'postChangeEmail'
export const CANCEL_CHANGE_EMAIL = 'postCancelChangeEmail'

export const USER_ID = 'getUserID'
export const DISPLAYNAME = 'getDisplayName'
export const EMAIL = 'getEmail'
export const NEW_EMAIL = 'getNewEmail'
export const PROFILE_URL = 'getProfileURL'
export const ACTIVATE = 'getActivate'
export const UNIQUE_ID = 'getUniqueID'
export const ALLOW_CHANGE_EMAIL = 'getAllowChangeEmail'
export const PROVIDERS = 'getProviders'
export const RISK_PROFILE = 'getRiskProfile'
export const TEL = 'getTel'
export const PROFILE_IMAGE = 'getProfileImage'
export const UNLINK_PROVIDER = 'patchUnlinkProvider'
